import React from "react";

function AboutHeadline({ content }) {
    return <h3 className="about__headline">{content}</h3>;
}

export default AboutHeadline;
